/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-16 09:20:48
 */ 
export const InvoiceCn = {
  fapiaoxinxiguanl: "发票信息列表",
  qsrfpttsjh: "请输入发票抬头\手机号",
  addfp: "新增发票",
  sprsj: "收票人手机：",
  sprdz: "收票人地址：",
  spryx: "收票人邮箱：",
  geren: "个人",
  gongsi: "公司",
  kaihuyh: "开户银行：",
  yhzhuanghu: "银行账户：",
  yingheng: "银行",
  ptfp: "普通发票",
  zzsfp: "增值税发票",
  fptt: "发票抬头：",
  ttmc: "抬头名称：",
  nsrsbh: "纳税人识别号：",
  sprsf: "收票人省份：",
  xxdz: "详细地址：",
  zcdh: "注册电话：",
  zcdz: "注册地址：",
  xiugaifpxx: "修改发票信息",
  xinzengfpxx: "新增发票信息",
  xuanzhefp: "选择发票",
  qsrttmcnsrsbh: "请输入抬头名称/纳税人识别号",
  morenfp: "默认发票",
  danweimc: "单位名称：",
  shouprxm: "收票人姓名：",
  fapiaoleixin: "发票类型",
  fapiaofenlei: "发票分类",
}
  


// WEBPACK FOOTER //
// ./src/lang/member/Invoice/InvoiceCn.js